export default __webpack_public_path__ + "static/media/endRound1.b86d46f0.mp3";